import { APICore } from './apiCore';

const api = new APICore();

export interface GetOrdersParams {
    customerId?: string | number;
    status?: 'PENDING' | 'COMPLETED' | 'CANCELLED' | 'PROCESSING';
    deliveryStatus?: 'PENDING' | 'IN_PROGRESS' | 'DELIVERED' | 'CANCELLED';
    paymentStatus?: 'PENDING' | 'PAID' | 'FAILED';
    startDate?: string;
    endDate?: string;
    sortBy?: string;
    sortType?: 'asc' | 'desc';
    limit?: number;
    page?: number;
    order?: 'dailybookings' | 'others';
}

// Get All Orders
function getOrders(params: GetOrdersParams) {
    const baseUrl = '/orders';
    // Strip out undefined / empty string params before sending
    const filteredParams: Record<string, any> = {};
    (Object.keys(params) as (keyof GetOrdersParams)[]).forEach((key) => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
            filteredParams[key] = val;
        }
    });
    return api.get(baseUrl, filteredParams);
}

// Get Order Details by ID
function getOrderDetails(orderId: string) {
    const baseUrl = `/orders/${orderId}`;
    return api.get(baseUrl, '');
}

// Update Order Status
function updateOrder(vendorId: number, orderId: string) {
    const baseUrl = `/vendors/${vendorId}/orders/${orderId}/status`;
    return api.update(baseUrl, {});
}

// Force Cancel Booking
function forceCancelBooking(bookingId: number, data: { reason: string; notes: string }) {
    const baseUrl = `/mybookings/${bookingId}/force-cancel`;
    return api.create(baseUrl, data);
}

// Force Cancel Entire Order
function forceCancelOrder(orderId: string, data: { reason: string; notes: string }) {
    const baseUrl = `/orders/${orderId}/force-cancel`;
    return api.create(baseUrl, data);
}

// Force Cancel Item
function forceCancelItem(orderId: string, itemId: number, data: { reason: string; notes: string }) {
    const baseUrl = `/orders/${orderId}/items/${itemId}/cancel`;
    return api.create(baseUrl, data);
}

export { getOrders, getOrderDetails, updateOrder, forceCancelBooking, forceCancelOrder, forceCancelItem };